import React, { useCallback, useEffect } from 'react';
import { Contexts } from '../../context';
import { Router } from 'react-router';
import { listenCallback, blockCallback, history } from '../../core/history';

const ConnectedRouter = ({ children }) => {
  const { dispatch } = Contexts();

  const upgradeHistory = useCallback(({ location, action }) => {
    dispatch({
      type: 'upgrade',
      payload: {
        router: {
          location,
          action
        }
      }
    });
  }, []);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      listenCallback(location, action);
      upgradeHistory({
        location,
        action
      });
    });
    const unblock = history.block(blockCallback);

    upgradeHistory({
      location: history?.location,
      action: history?.action
    });

    return () => {
      unblock();
      unlisten();
    };
  }, []);

  return <Router history={history}>{children}</Router>;
};

export default ConnectedRouter;
